export default {
	email: {
        send_email: 'https://lucban-e-commerce-api.herokuapp.com/api/send-email',
        // send_email: 'http://127.0.0.1:8000/api/send-email',
    },
}